import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const MainContainer = styled.div`
  ${tw`hidden md:flex gap-1 p-1 bg-input-blue border border-gray94 rounded-1000px`}
`;
